/*!

=========================================================
* Material Dashboard PRO React - v1.7.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import termsPageStyles from "assets/jss/material-dashboard-pro-react/views/termsPageStyles.jsx";

class ThirdPartyPrivacy extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <GridContainer justify="center" style={{ zIndex: 3 }}>
        <GridItem xs={12} sm={12} md={6}>
          <div className={classes.contentCenter}>
            <section>
              <div class="frame">
                <h3>개인정보 제3자 제공 별도 동의</h3>
              </div>
            </section>

            <section>
              <div class="frame">
                <h5>[개인정보 수집&middot;이용 동의]</h5>
                <h5>①&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 개인정보의 수집&middot;이용목적</h5>
                <h5>가.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 개인정보의 처리 목적 ('enbrain.org'이하 '엔브레인플랫폼')은(는) 개인정보를 다음의 목적을 위해 처리합니다. 처리한 개인정보는 다음의 목적 이외의 용도로는 사용되지 않으며 이용 목적이 변경될 시에는 사전동의를 구할 예정입니다</h5>
                <h5>나.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 회원가입 및 관리 : 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별&middot;인증, 회원자격 유지&middot;관리, 제한적 본인 확인제 시행에 따른 본인확인, 서비스 부정이용 방지, 각종 고지&middot;통지, 고충처리, 분쟁 조정을 위한 기록 보존 등을 목적으로 개인정보를 처리합니다.</h5>
                <h5>다.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 민원사무처리 : 민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락&middot;통지, 처리결과 통보 등을 목적으로 개인정보를 처리합니다.</h5>
                <h5>라.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 재화 또는 서비스 제공: 서비스 제공, 콘텐츠 제공, 맞춤 서비스 제공, 본인인증, 연령 인증, 요금 결제&middot;정산 등을 목적으로 개인정보를 처리합니다.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h5>
                <h5>마.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 마케팅 및 광고에의 활용 : 이벤트 및 광고성 정보 제공 및 참여기회 제공 , 인구통계학적 특성에 따른 서비스 제공 및 광고 게재 , 서비스의 유효성 확인, 접속빈도 파악 또는 회원의 서비스 이용에 대한 통계 등을 목적으로 개인정보를 처리합니다.</h5>
                <h5>②&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 수집하려는 개인정보의 항목</h5>
                <h5>가.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 개인정보 파일명 : 인지지원서비스 서식</h5>
                <h5>나.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 개인정보 항목 : 이메일, 휴대전화번호, 로그인ID, 성별, 생년월일, 이름, 신체 정보, 학력, 종교</h5>
                <h5>다.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 수집방법 : 회원가입, 서면 양식, 제휴사로부터 제공</h5>
                <h5>③&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 개인정보의 보유 및 이용 기간</h5>
                <h5>가.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ('엔브레인플랫폼')은(는) 법령에 따른 개인정보 보유&middot; 이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유&middot; 이용기간 내에서 개인정보를 처리,보유합니다.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h5>
                <h5>나.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h5>
                <h5>개인정보는 수집&middot; 이용에 관한 동의일로부터까지 위 이용목적을 위하여 보유&middot; 이용됩니다.&nbsp;&nbsp;&nbsp;&nbsp;</h5>
                <h5>(ㄱ)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 보유근거 : 개인정보처리방침</h5>
                <h5>(ㄴ)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 보유기간 : 준영구</h5>
                <h5>(ㄷ)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 관련법령의 소비자의 불만 또는 분쟁 처리에 관한 기록 : 3년&nbsp;&nbsp;</h5>
                <h5>(ㄹ)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 관련법령의 계약 또는 청약철회 등에 관한 기록 : 5년&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h5>
                <h5>④&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 동의를 거부할 수 있으며, 동의 거부 시 엔브레인플랫폼 서비스가 제공되지 않습니다.</h5>
                <h5>&nbsp;</h5>
                <h5><u>위 개인정보 수집 이용에 동의하십니까?</u> □ 예 &nbsp;&nbsp;&nbsp;&nbsp;□ 아니오</h5>
                <h5>&nbsp;</h5>
                <h5>[개인정보 제3자 제공에 대한 별도 동의]</h5>
                <h5>①&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ('enbrain.org'이하 '엔브레인플랫폼')은(는) 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조 및 제18조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</h5>
                <h5>②&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; ('enbrain.org')은(는) 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.</h5>
                <h5>(ㄱ)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 개인정보를 제공받는 자 : 주식회사 캐어유</h5>
                <h5>(ㄴ)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 개인정보를 제공받는 자의 개인정보 이용 목적 : 이메일, 휴대전화번호, 로그인ID, 성별, 생년월일, 이름, 신체 정보, 학력, 종교</h5>
                <h5>(ㄷ)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 제공받는 자의 보유 이용기간 : 준영구</h5>
                <h5>&nbsp;</h5>
                <h5><u>위 개인정보의 제3자 제공에 동의하십니까? </u>□ 예 &nbsp;&nbsp;&nbsp;&nbsp;□ 아니오</h5>
                <h5>&nbsp;</h5>
              </div>
            </section>
          </div>
        </GridItem>
      </GridContainer>
    );
  }
}

ThirdPartyPrivacy.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(termsPageStyles)(ThirdPartyPrivacy);
